import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { IItemTiming } from './item-timing.interface';

@Injectable({ providedIn: 'root' })
export class ItemTimingService {
  constructor(private readonly http: HttpClient) {}

  /** Statuses, elapsed times and planned windows of every work instruction of the item, calculated by the API. */
  public getItemTimings(itemKey: string): Observable<IBaseResponse<IItemTiming>> {
    return this.http.get<IBaseResponse<IItemTiming>>(`items/timings/${encodeURIComponent(itemKey)}`);
  }
}
